import React, { Component } from 'react'
import PropTypes from 'prop-types'
import constants from 'common/helpers/constants'
import actions from 'redux/actions'
import moment from 'moment'
import { FormattedMessage } from 'sb-react-intl'

import Calendar from 'components/ui/Calendar/Calendar'
import BackNextModal from 'components/modal/BackNextModal/BackNextModal'

import s from './PickDateModal.scss'
import messages from './messages.js'


class PickDateModal extends Component {

  static propTypes = {
    data: PropTypes.shape({
      onNext: PropTypes.func.isRequired,
      onPickDate: PropTypes.func.isRequired,
    }),
    name: PropTypes.string,
  }

  static defaultProps = {
    name: constants.modals.PickDate,
  }

  handleClose = () => {
    const { name } = this.props

    actions.models.modals.close(name)
  }

  goBack = () => {
    const { data: { onBack } } = this.props

    this.handleClose()
    onBack()
  }

  goNext = () => {
    const { data: { onNext } } = this.props

    this.handleClose()
    onNext()
  }

  pickDate = (date) => {
    const { data: { onPickDate } } = this.props

    onPickDate(moment(date).format('MM/DD/YYYY'))
  }

  render() {
    const { name } = this.props

    return (
      <BackNextModal
        name={name}
        nextButtonId="giftNextButton"
        dataTestId={constants.testIds.modal.pickDateModal}
        onClose={this.goBack}
        onBack={this.goBack}
        onNext={this.goNext}
      >
        <div className={s.calendarContainer}>
          <FormattedMessage className={s.title} tag="div" {...messages.title} />
          <Calendar className={s.calendar} onSelect={this.pickDate} />
          <FormattedMessage className={s.hint} tag="div" {...messages.hint} />
        </div>
      </BackNextModal>
    )
  }
}


export default PickDateModal
